import React, { Component } from 'react';
// import PropTypes from 'prop-types';

// @atlaskit
import Select from '@atlaskit/select';

// @source
import { Report as APIs } from '../../../../server';
import { path } from '../../../../utils';
import {
  Messages,
  QueryBuilder,
  Fragment,
  ConvertQuery,
} from '../../../components';

const initialState = {
  columns: [],
  isLoading: true,
  message: false,
  report: '',
  reports: [],
};

const send = (message) => {
  const { postMessage } = window;

  if (postMessage) {
    postMessage(JSON.stringify(message));
  }
};

class Excel extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.handleChangeReport = this.handleChangeReport.bind(this);
    this.handleCloseMessage = this.handleCloseMessage.bind(this);
  }

  componentWillMount() {
    this.fetchReportList();
  }

  fetchReportList() {
    const token = path.parse('token');
    let report = path.parse('report');

    APIs.fetch({
      data: { token },
      success: (reports) => {
        if (report) {
          report = decodeURIComponent(path.parse('report'));
          send({ report });
          this.fetchReportColumns(report);
        }
        this.setState({ report, reports });
      },
      error: (messages) => {
        this.setState({
          message: (
            <Messages
              items={messages}
              onClose={this.handleCloseMessage}
            />
          ),
        });
      },
    });
  }

  fetchReportColumns(report) {
    const token = path.parse('token');

    APIs.columns({
      data: { report, token },
      success: (columns) => {
        this.setState({ columns });
      },
      error: (messages) => {
        this.setState({
          message: (
            <Messages
              items={messages}
              onClose={this.handleCloseMessage}
            />
          ),
        });
      },
    });
  }

  handleChangeReport({ value }) {
    send({ report: value });
    this.fetchReportColumns(value);
    this.setState({
      report: value,
      columns: [],
    });
  }

  handleCloseMessage() {
    this.setState({ message: false });
  }

  renderSelect() {
    const { report, reports } = this.state;
    const options = reports.map(item => ({
      label: item.Name,
      value: item.Name,
    }));

    return (
      <Select
        isLoading={!reports.length}
        isSearchable={false}
        onChange={this.handleChangeReport}
        options={options}
        placeholder="Select a report"
        value={options.find(item => item.value === report)}
      />
    );
  }

  renderQueryBuilder() {
    const { columns } = this.state;

    return (
      <QueryBuilder
        isMobile
        fields={columns.map(elem => ({
          name: elem.ColumnName,
          type: elem.ColumnType,
        }))}
        output={(template) => {
          const query = ConvertQuery(template);
          send({ query });
        }}
      />
    );
  }

  render() {
    const { columns, message } = this.state;
    const container = {
      boxSizing: 'border-box',
      minWidth: '100%',
      padding: 15,
    };

    return (
      <Fragment>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />
        <div style={container}>
          {this.renderSelect()}
          {columns.length ? this.renderQueryBuilder() : null}
          {message}
        </div>
      </Fragment>
    );
  }
}

export default Excel;
